export default "__VITE_ASSET__FyMV8yJ$__"